import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

import { Row, Col, Button, DatePicker } from 'antd';

@inject('commonStore')
@observer
export default class RangeFilter extends Component {
  handleReset = clearFilters => () => {
    clearFilters();
    this.props.handleReset && this.props.handleReset();
  };

  handleSearch = () => {
    this.props.confirm();
    this.props.handleSearch && this.props.handleSearch(this.state.selectedKeys);
  };

  onChange = range => {
    this.props.setSelectedKeys(range);
    this.setState({ selectedKeys: range }, () => {
      this.handleSearch();
    });
  };

  render() {
    return (
      <Row id="RangePicker" className="RangePicker">
        <DatePicker.RangePicker
          value={this.props.selectedKeys}
          getCalendarContainer={() => document.getElementById('RangePicker')}
          format={this.props.commonStore.longDateFormat.L}
          onChange={this.onChange}
          autoFocus={true}
        />
      </Row>
    );
  }
}
